import { render, staticRenderFns } from "./PePager.vue?vue&type=template&id=fc59fea6&"
import script from "./PePager.vue?vue&type=script&lang=js&"
export * from "./PePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports